import { RouterModule, Routes } from '@angular/router';

import { RsaAuthGuardService } from '@services';

import { SearchComponent } from './search/search.component';
import { UserDetailsComponent } from './user-details/user-details.component';

export const searchRoutes: Routes = [
  {
    path: 'search',
    component: SearchComponent,
    canActivate: [RsaAuthGuardService],
  },
  {
    path: 'users/:id',
    component: UserDetailsComponent,
    canActivate: [RsaAuthGuardService],
  },
];

export const SearchRouting = RouterModule.forChild(searchRoutes);
